class SmoothScroll {
  scrollTo (element) {
    let start = element.scrollTop,
        to = 0,
        duration = 250,
        change = to - start,
        currentTime = 0,
        increment = 20

      let easeInOutQuad = function (t, b, c, d) {
        t /= d/2
        if (t < 1) return c/2*t*t + b
        t--
        return -c/2 * (t*(t-2) - 1) + b
      }
        
      let animateScroll = function(){        
          currentTime += increment
          let val = easeInOutQuad(currentTime, start, change, duration)
          element.scrollTop = val
          if(currentTime < duration) {
              setTimeout(animateScroll, increment)
          }
      };
      animateScroll()
  }
}

export default SmoothScroll



// WEBPACK FOOTER //
// ./src/modules/plugins/smooth-scroll.js